import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
  VStack,
  Spinner,
} from "@chakra-ui/react";
import { useCognito } from "../utils/useCognito"; // Assume you have a Cognito hook
import "../styles.css";
export default function Login() {
  // Already using useCognito
  const { login, isAuthenticated, isLoading } = useCognito();
  const navigate = useNavigate();

  // Add state for username and password
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // ✅ Auto-redirect if user is already logged in
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  // ✅ If loading, show spinner
  if (isLoading) {
    return (
      <Flex minH="100vh" align="center" justify="center">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <Flex className="gradient-background" minH="50vh" align="center" justify="center">
      <Container className="login-container card" maxW="md" p={6}>
        <Box textAlign="center" mb={6}>
          <Heading as="h2" size="lg" color="var(--primary-color)">
            Login to Your Administrator Account
          </Heading>
          <Text color="var(--text-color)">Enter your credentials to log in securely.</Text>
        </Box>

        <VStack spacing={4}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            style={{ width: "100%", padding: "10px", fontSize: "1rem", borderRadius: "6px", border: "1px solid #ccc" }}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ width: "100%", padding: "10px", fontSize: "1rem", borderRadius: "6px", border: "1px solid #ccc" }}
          />
          {error && <Text color="red.500">{error}</Text>}
          <Button
            onClick={async () => {
              setError("");
              if (!username || !password) {
                setError("Please enter both username and password.");
                return;
              }
              try {
                await login(username, password);
              } catch (err) {
                setError(err.message || "Login failed.");
              }
            }}
            bg="var(--button-color)"
            color="white"
            size="lg"
            _hover={{ bg: "var(--button-hover-color)" }}
            width="full"
          >
            Login / Sign Up
          </Button>
        </VStack>
      </Container>
    </Flex>
  );
}